export const FORM_CONSTANTS = {
  BREADCRUMB: {
    TITLE: "DCCM Quarterly Bonus Form",
    PATH: "/DCCM",
  },
  HEADER: {
    TITLE: "DCCM Quarterly Bonus Form",
    SUBTITLE:
      "Achievement of Targets is a subjective determination in the Employer's sole discretion. The Employer may change the percentages or Targets at any time.",
  },
  LAYOUT: {
    MAX_WIDTH: "max-w-9xl",
    PADDING: "px-4 sm:px-6 lg:px-8",
    SPACING: {
      BREADCRUMB: "mb-6",
      CONTENT: "space-y-4",
    },
  },
  SECTIONS: {
    OPERATIONAL_EFFICIENCY: {
      TITLE: "OPERATIONAL EFFICIENCY",
      CUSTOMER_CARE_EXPENSE: {
        TITLE: "Customer Care Expense (30% of total achievement score)",
        DESCRIPTION:
          "This will be evaluated from monthly financial reports. The goal is meet budget.",
      },
    },
    CUSTOMER_EXPERIENCE: {
      TITLE: "CUSTOMER EXPERIENCE",
      CUSTOMER_CARE_CALLS: {
        TITLE: "Customer Care Calls (70% of total achievement score)",
        DESCRIPTION:
          "This will be evaluated from calls completed within 7 days. The goal is 70% of all calls completed within 7 days.",
      },
    },
    BONUS_CALCULATION: {
      TITLE: "BONUS CALCULATION",
      TOTAL_ACHIEVEMENT: "Total Achievement Score",
    },
  },
  PAYOUT_TIERS: {
    CUSTOMER_CARE_CALLS: [
      { actual: "80%", payout: "120%" },
      { actual: "75%", payout: "110%" },
      { actual: "70%", payout: "100%" },
      { actual: "66%", payout: "95%" },
      { actual: "63%", payout: "90%" },
      { actual: "56%", payout: "80%" },
      { actual: "50%", payout: "50%" },
      { actual: "49% or less", payout: "0%" },
    ],
  },
  OPS: {
    NAME: "Angie Hayes",
    EMAIL: "Angie.Hayes@highlandhomes.com",
  }
};
